import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { useDashboardBreadcrumb } from './DashboardBreadcrumbContext';

export default function VerificationBreadcrumb({ rootLabel = 'Individuals', rootTo = '/dashboard/verifications', current, showDashboard = true }) {
  const location = useLocation();
  const hasCurrent = Boolean(current);
  const isInternalRoute = location.pathname.startsWith('/internal/');
  const effectiveRootTo = isInternalRoute && typeof rootTo === 'string' && rootTo.startsWith('/admin/')
    ? rootTo.replace(/^\/admin/, '/internal')
    : rootTo;
  const effectiveShowDashboard = isInternalRoute ? false : showDashboard;
  const { setBreadcrumb } = useDashboardBreadcrumb();

  useEffect(() => {
    setBreadcrumb({ rootLabel, rootTo: effectiveRootTo, current, showDashboard: effectiveShowDashboard });
    return () => setBreadcrumb(null);
  }, [current, effectiveRootTo, effectiveShowDashboard, rootLabel, setBreadcrumb]);

  return (
    <nav
      aria-label="Breadcrumb"
      className="sticky top-16 z-30 -mt-8 mb-8 h-12 md:hidden"
    >
      <div className="absolute inset-y-0 left-1/2 w-screen -translate-x-1/2 border-b border-zinc-200 bg-white md:w-[calc(100vw-12rem)]"/>
      <div className="relative h-full flex items-center min-w-0">
        <ol className="flex items-center gap-2.5 min-w-0 w-full text-[15px]">
          {effectiveShowDashboard && (
            <>
              <li className="shrink-0">
                <Link to="/dashboard" className="font-normal text-zinc-400 hover:text-zinc-600">
                  Dashboard
                </Link>
              </li>
              <li className="shrink-0 text-zinc-300" aria-hidden="true">
                <ChevronRight className="w-4 h-4" strokeWidth={1.8}/>
              </li>
            </>
          )}
          <li className={`min-w-0 ${hasCurrent ? 'shrink-0' : 'font-semibold text-zinc-900 truncate'}`} title={rootLabel}>
            {hasCurrent ? (
              <Link to={effectiveRootTo} className="font-normal text-zinc-400 hover:text-zinc-600">
                {rootLabel}
              </Link>
            ) : (
              rootLabel
            )}
          </li>
          {hasCurrent ? (
            <>
              <li className="shrink-0 text-zinc-300" aria-hidden="true">
                <ChevronRight className="w-4 h-4" strokeWidth={1.8}/>
              </li>
              <li className="font-semibold text-zinc-900 truncate min-w-0" title={current}>
                {current}
              </li>
            </>
          ) : null}
        </ol>
      </div>
    </nav>
  );
}
